/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Select_HintInputs */

const cs_settings_teams_select_hint = /** @type {(inputs: Settings_Teams_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlevo vyberte tým, uvidíte členy.`)
};

const en_settings_teams_select_hint = /** @type {(inputs: Settings_Teams_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a team on the left to see members.`)
};

/**
* | output |
* | --- |
* | "Pick a team on the left to see members." |
*
* @param {Settings_Teams_Select_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_select_hint = /** @type {((inputs?: Settings_Teams_Select_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Select_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_select_hint(inputs)
	return cs_settings_teams_select_hint(inputs)
});